import MilkType from "./MilkType";

export default function TbTR1({data}) {
    // eslint-disable-next-line
    let lr = data.data;

    function SiloRow({num}){
      // eslint-disable-next-line
      let lbs = eval("lr.tr1_tr"+num+"_lbs");
      // eslint-disable-next-line
      let temp = eval("lr.tr1_tr"+num+"_temp");
      // eslint-disable-next-line
      let pa = eval("lr.tr1_tr"+num+"_pa") === "Yes";
      // eslint-disable-next-line
      let mTypeId = eval("lr.tr_tr"+num+"_type");
      let mType = MilkType.find(x => x.id === 0);
      if (mTypeId === undefined) {
        if (pa) {
          mType = MilkType.find(x => x.id === 6);
        }
      }
      else {
        mType = MilkType.find(x => x.id === mTypeId);
      }
      return (
        <tr>
          <td className={mType.style}>{num} {mType.id > 0 && <sup>{mType.code}</sup>}</td>
          <td className={mType.style}>{lbs}</td>
          <td className={mType.style}>{temp}</td>
        </tr>
      )
    }

    return (
      <>
        <div className="card card-table mb-4 rounded-1 shadow-sm">
          <div className="card-header py-2">
            <h4 className="my-0">TR-1</h4>
          </div>
          <div className="card-body nopadding">
            <table className="table table-sm my-0 tbl">
              <thead>
                <tr>
                  <th scope="col">Silo</th>
                  <th scope="col">Lbs</th>
                  <th scope="col">Temp</th>
                </tr>
              </thead>
              <tbody>
                <SiloRow num="1" />
              </tbody>
            </table>
          </div>
        </div>

      </>
    )
}